import React from 'react';
import styles from './index.module.scss';
import closeIcon from '../../../../../assets/images/close.png';

interface RemoveFolderModalProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
  folderTitle: string;
}

const RemoveFolderModal: React.FC<RemoveFolderModalProps> = ({
  isOpen,
  toggle,
  onConfirm,
  folderTitle
}) => {
  const handleConfirm = () => {
    onConfirm();
    toggle();
  };

  const handleCancel = () => {
    toggle();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleCancel}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Remove Folder</h3>
          <button className={styles.closeButton} onClick={handleCancel}>
            <img src={closeIcon} alt="Close" className={styles.closeIcon} />
          </button>
        </div>
        
        <div className={styles.modalBody}>
          <p className={styles.confirmationText}>
            Are you sure you want to remove the folder <strong>"{folderTitle}"</strong> from this template? 
            This action will disconnect the folder from the template but will not delete the folder itself.
          </p>
        </div>
        
        <div className={styles.modalFooter}>
          <button onClick={handleCancel} className={styles.cancelButton}>
            Cancel
          </button>
          <button onClick={handleConfirm} className={styles.removeButton}>
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveFolderModal;
